import { ResponseNationalityManagerCreate, RequestNationalityManagerCreate } from '../../shared/interfaces';
import { createReducer, on } from '@ngrx/store';
import { NationalityManagerCreateActions } from '../actions';
import { NationalityManagerCreateTypes } from '../../shared/enums';

export interface NationalityManagerCreateState {
    response: ResponseNationalityManagerCreate;
    request: RequestNationalityManagerCreate;
    error: any;
}

export const NationalityManagerCreateInitialState: NationalityManagerCreateState = {
    response: null,
    request: null,
    error: null
};

const _nationalityManagerCreateReducer = createReducer(
    NationalityManagerCreateInitialState,

    on(NationalityManagerCreateActions.getNationalityManagerCreate, (state, { request }) => ({
        ...state,
        request,
        error: null
    })),

    on(NationalityManagerCreateActions.getNationalityManagerCreateSucess, (state, { response }) => ({
        ...state,
        response,
        error: null
    })),

    on(NationalityManagerCreateActions.getNationalityManagerCreateError, (state, { payload }) => ({
        ...state,
        request: null,
        response: null,
        error: {
            statusCode: payload.statusCode,
            message: payload.message
        }
    })),

    on(NationalityManagerCreateActions.cleanState, (state) => ({
        ...state,
        request: null,
        response: null,
        error: null
    }))
);

export function nationalityManagerCreateReducer(state, action) {
    if (action.type === NationalityManagerCreateTypes.NATIONALITY_MANAGER_CREATE) {
        state = undefined;
    }
    return _nationalityManagerCreateReducer(state, action);
}
